import { render, staticRenderFns } from "./adjacentArticle.vue?vue&type=template&id=7d5e4a22&scoped=true&"
import script from "./adjacentArticle.vue?vue&type=script&lang=js&"
export * from "./adjacentArticle.vue?vue&type=script&lang=js&"
import style0 from "./adjacentArticle.vue?vue&type=style&index=0&id=7d5e4a22&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5e4a22",
  null
  
)

export default component.exports